import { lazy } from '@loadable/component';
export type { MarkdownRendererProps } from './Markdown';

export default lazy(() => import('./Markdown'));
